import { Icon } from "@iconify/react";

interface HeaderProps {
  isDarkMode: boolean;
  isSidebarOpen: boolean;
  setIsSidebarOpen: (open: boolean) => void;
  toggleDarkMode: () => void;
  selectedSessionName: string | null;
}

export const Header = ({
  isDarkMode,
  isSidebarOpen,
  selectedSessionName,
  setIsSidebarOpen,
  toggleDarkMode,
}: HeaderProps) => {
  return (
    <header
      className={[
        "grid",
        "grid-cols-[auto_1fr_auto]",
        "items-center",
        "gap-2",
        "md:gap-4",
        "p-2",
        "md:p-4",
        "border-b",
        "min-w-0",
        isDarkMode ? "border-gray-700 bg-gray-800" : "border-gray-200 bg-white",
      ].join(" ")}
    >
      {!isSidebarOpen ? (
        <button
          type="button"
          onClick={() => setIsSidebarOpen(true)}
          className={[
            "w-8",
            "h-8",
            "rounded",
            "grid",
            "place-items-center",
            "transition-colors",
            isDarkMode ? "bg-gray-700 hover:bg-gray-600" : "bg-gray-100 hover:bg-gray-200",
          ].join(" ")}
          aria-label="Open sidebar"
        >
          <Icon
            icon="mdi:menu"
            className={`w-5 h-5 ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}
          />
        </button>
      ) : (
        <div />
      )}
      <h4
        className={`text-base md:text-lg font-semibold truncate ${isDarkMode ? "text-gray-100!" : "text-gray-900!"}`}
      >
        Quotation Request Chat{selectedSessionName ? ` - ${selectedSessionName}` : ""}
      </h4>
      <div className="grid grid-flow-col gap-1 md:gap-2">
        <button
          type="button"
          onClick={toggleDarkMode}
          className={[
            "w-8",
            "h-8",
            "rounded-lg!",
            "grid",
            "place-items-center",
            "transition-colors",
            isDarkMode ? "bg-gray-700 hover:bg-gray-600" : "bg-gray-100 hover:bg-gray-200",
          ].join(" ")}
          aria-label="Toggle dark mode"
        >
          {isDarkMode ? (
            <Icon icon="mdi:weather-sunny" className="w-5 h-5 text-yellow-500" />
          ) : (
            <Icon
              icon="mdi:weather-night"
              className={`w-5 h-5 ${isDarkMode ? "text-gray-300" : "text-gray-700"}`}
            />
          )}
        </button>
      </div>
    </header>
  );
};
